<script>
export default {
  name: "listingLocation",
  props: {
    listingDetails: Object
  }
};
</script>

<template>
  <el-row style="padding: 10px 5px; background-color: #ffffff">
    <el-col :span="24" style="border-radius: 20px; overflow: hidden;">
      <el-row>
        <el-col :span="24">
          <GmapMap
            :center="{
              lat: listingDetails.latitude,
              lng: listingDetails.longitude
            }"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false
            }"
            :zoom="15"
            class="img-13"
            style="width: 100%; height: 250px"
          >
            <GmapMarker
              :icon="require('../../assets/location.png')"
              :position="{
                lat: listingDetails.latitude,
                lng: listingDetails.longitude
              }"
            />
          </GmapMap>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="24"
          style="background-color: #003333; color: #ffffff; padding: 2% 2% 0.5% 2%;"
        >
          <span style="font-weight: 500;font-size: 18px;"  class="text-dino">{{
              listingDetails.propertyLocationTitle
                ? listingDetails.propertyLocationTitle
                : "Location,location!"
            }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          style="background-color: #003333; color: #ffffff; padding: 1% 2% 3% 2%;"
        >
          <span style="font-weight: 300; font-size: 16px;" class="text-dino">{{
              listingDetails.propertyLocationDescription
            }}</span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.text-dino {
  font-family: DINosaur-a, sans-serif;
  line-height: 125%;
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/listingLocation.vue